import React from "react";
import Heading from "../../../../../../shared/Heading/Heading";
import ImageCarousel from "../../../../../../shared/ImageCarousel/ImageCarousel";
import Button from "../../../../../../shared/Button/Button";
import Markdown from "markdown-to-jsx";

const LocationDetailsDesktop = ({
  hotelDetailsLocation,
  updateHotelSelection,
  setHotelDetailsLocation,
  setView,
}) => {
  return (
    <>
      <Heading
        txt={hotelDetailsLocation.Title}
        new_styles={{
          paddingBottom: "24px",
          textAlign: "center",
          font: "normal normal bold 26px/28px Crimson Pro",
          color: "#545E88",
        }}
      />
      <div style={{ display: "flex", marginBottom: "20px" }}>
        <div style={{ width: "50%", height: "500px" }}>
          <ImageCarousel
            sliderImages={hotelDetailsLocation.Images}
            customImageStyles={{ borderRadius: "0" }}
          />
        </div>
        <div
          style={{
            width: "50%",
            height: "500px",
            padding: "0px 5px 0px 15px",
            overflow: "auto",
          }}
        >
          <div style={{ paddingTop: "5px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                style={{ width: "24px", height: "32px" }}
                src={`/img/day_use_icons/location-pin-blue.svg`}
                alt=""
              />
              <span
                style={{
                  fontSize: "16px",
                  paddingLeft: "5px",
                  color: "#949496",
                }}
              >
                {hotelDetailsLocation.Address}
              </span>
            </div>

            {hotelDetailsLocation.LongDescription && (
              <p style={{ paddingTop: "20px" }}>
                <Markdown>{hotelDetailsLocation.LongDescription}</Markdown>
              </p>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p
          style={{
            color: "#699DB0",
            font: "normal normal 600 18px/22px Open Sans",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            setView({ type: "show-hotels-details" });
            setHotelDetailsLocation(null);
          }}
        >
          {"Back"}
        </p>

        <Button
          txt={"Switch to this hotel"}
          onClick={() => {
            updateHotelSelection(hotelDetailsLocation.id);
            setView({ type: "show-activities" });
          }}
          backgroundColor={"#699DB0"}
          newStyles={{ border: "none" }}
          minHeight={55}
          height={55}
          opacity={!hotelDetailsLocation.AllowDayUseAppearance ? "0.4" : 1}
          pointerEvents={!hotelDetailsLocation.AllowDayUseAppearance && "none"}
        />
      </div>
    </>
  );
};

export default LocationDetailsDesktop;
